module.exports = __webpack_public_path__ + "media/images/icons/fecha-asegurada-47d81630f7c53638735bc4ddf4223de3.svg";